<template>
  <a-cascader @change="changeXzc" :expandTrigger="expandTriggerType" :fieldNames="{label:'departName',value:'orgCode',children:'children'}" :allowClear="false"  :value="getValueSting" :options="options" :changeOnSelect="true"  :placeholder="placeholder" />
</template>
<script>
import { getAction } from '@/api/manage'

export default {
  name: 'OrgSelect',
  props: {
    orgType: String,
    value: String,
    placeholder: String,
    expandTriggerType:{
      type:String,
      default:"click"
    },
    userXzzz:{
      type:Boolean,
      default:true
    },
    getPopupContainer:{
      type: Function,
      default: (node) => node.parentNode
    }
  },

  data() {
    return {
      options: [],
      defaultValue:[]
    };
  },
  created() {
    this.$nextTick(() => {
      this.initAreaData();
    })
  },
  computed: {
      getValueSting(){
        // update-begin author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
        // 当有null或“” placeholder不显示
        if(this.value != null){
          var defaultValueThis = [];
          // if(this.options.length>0){
          //   for(var i=0;i<=(this.value.length-this.options[0].orgCode.length)/3;i++){
          //     defaultValueThis.push(this.value.substr(0,this.options[0].orgCode.length+(i)*3));
          //   }
          // }
          if(this.options.length>0){
            for(var i=0;i<(this.value.length)/3;i++){
              defaultValueThis.push(this.value.substr(0,(i+1)*3));
            }
          }
          return defaultValueThis;
        }else{
          return undefined;
        }
        // update-end author:wangshuai date:20200601 for: 不显示placeholder的文字 ------
      },
  },
  methods: {
    changeXzc(value) {
      this.defaultValue = value;
      var val='';
      if(value.length>0){
        val=value[value.length-1];
      }
      this.value = val;
      this.$emit('input', val);
      this.$emit('change', val);
    },
    initAreaData(){
        this.options = [];
        getAction('/sys/sysDepart/queryTreeList/by/orgType?orgType='+this.orgType+"&userXzzz="+this.userXzzz,{}).then((res)=>{
          let orgList = res.result;
          
          this.options = orgList;
        })
      },
  },
};
</script>